// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  overflow: hidden;
}

.slider-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  user-select: none;
  cursor: grab;
}
.slider-container:active {
  cursor: grabbing;
}

.slides-wrapper {
  display: flex;
  transition: transform var(--slide-speed, 500ms) ease-in-out;
  will-change: transform;
  gap: 0vh;
}

.slider-item {
  flex-shrink: 0;
  margin: 1vh;
  box-shadow: var(--shadow-m);
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  width: calc(100% - 2vh);
  z-index: 2;
  background: var(--ion-white-primary);
}
.slider-item img {
  width: 100% !important;
  height: 100%;
  object-fit: cover;
}

.squareTrue {
  aspect-ratio: 1/1;
}

.squareFalse {
  aspect-ratio: unset;
}

.onbSlider:host .slider-item {
  margin: 0px;
  width: 100%;
  height: 100vh !important;
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-slider/app-slider.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEI;EACF,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iBAAA;EAEA,YAAA;AAAF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,aAAA;EACA,2DAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAIA;EAEE,cAAA;EACC,WAAA;EACC,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,UAAA;EACA,oCAAA;AAHJ;AAIE;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;AAFJ;;AAKA;EACA,iBAAA;AAFA;;AAIA;EACA,mBAAA;AADA;;AAyDE;EACE,WAAA;EACA,WAAA;EACA,wBAAA;EACI,gBAAA;AAtDR","sourcesContent":[":host {\n  display: block; // Makes sure the component itself occupies space\n  width: 100%;\n  overflow: hidden; // Hide anything outside the slider container\n}\n\n    .slider-container {\n  position: relative;\n  width: 100%;\n  overflow: hidden; // This hides the slides that are off-screen\n  user-select: none;\n  user-select: none; // Prevent text selection during swipe\n\n  cursor: grab; // Indicate it's draggable\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n.slides-wrapper {\n  display: flex; // Arranges items in a row\n  transition: transform var(--slide-speed, 500ms) ease-in-out; // Use CSS variable for transition speed\n  will-change: transform; // Optimize for transform animations\n  gap: 0vh;\n       \n}\n\n.slider-item {\n  \n  flex-shrink: 0; // Prevent slides from shrinking\n   margin: 1vh;\n    box-shadow: var(--shadow-m);\n    border-radius: 20px;\n    position: relative;\n    overflow: hidden;\n    width: calc(100% - 2vh);\n    \n    z-index: 2;\n    background: var(--ion-white-primary);\n  img {\n    width: 100% !important;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n.squareTrue{\naspect-ratio: 1 / 1;\n}\n.squareFalse{\naspect-ratio: unset;\n}\n\n// .slider-nav {\n//   position: absolute;\n//   top: 50%;\n//   transform: translateY(-50%);\n//   background-color: rgba(0, 0, 0, 0.5);\n//   color: white;\n//   border: none;\n//   padding: 10px 15px;\n//   cursor: pointer;\n//   z-index: 10;\n//   font-size: 24px;\n//   opacity: 0.7;\n//   transition: opacity 0.3s ease;\n//               width: 40px;\n//             height: 1vw;\n//             border-radius: 12px;\n\n//   &:hover {\n//     opacity: 1;\n//   }\n//   &.prev {\n//     left: 10px;\n//   }\n//   &.next {\n//     right: 10px;\n//   }\n// }\n\n// .slider-pagination {\n//   position: absolute;\n//   bottom: 10px;\n//   left: 50%;\n//   transform: translateX(-50%);\n//   display: flex;\n//   gap: 8px;\n//   z-index: 10;\n\n//   span {\n//     display: block;\n//     width: 10px;\n//     height: 10px;\n//     border-radius: 50%;\n//     background-color: rgba(255, 255, 255, 0.5);\n//     cursor: pointer;\n//     transition: background-color 0.3s ease;\n\n//     &.active {\n//       background-color: white;\n//     }\n//   }\n// }\n\n.onbSlider:host{\n  .slider-item{\n    margin: 0px;\n    width: 100%;\n    height: 100vh !important;\n        border-radius: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
